import { render, staticRenderFns } from "./ObservationsReports.vue?vue&type=template&id=40dcea32&"
import script from "./ObservationsReports.vue?vue&type=script&lang=js&"
export * from "./ObservationsReports.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports